var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskCenteredLayout",
    { class: _vm.$style.confirmationPage, style: _vm.backgroundStyle },
    [
      _c(
        "div",
        { class: _vm.$style.confirmationContent },
        [
          _c("div", { class: _vm.$style.checkmark }, [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.checkmarkIcon,
              attrs: { symbol: "checkmark-icon" }
            })
          ]),
          _vm._v(" "),
          _c("KioskMessageTitle", {
            class: _vm.$style.confirmationTitle,
            attrs: { title: "We're preparing your order!" }
          }),
          _vm._v(" "),
          _c("p", { class: _vm.$style.confirmationText }, [
            _vm._v("\n      We will call your name when it is ready.\n    ")
          ]),
          _vm._v(" "),
          _c(
            "BaseButton",
            { class: _vm.$style.ghostBtn, on: { click: _vm.handleDone } },
            [_vm._v("\n      Done\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskConfirmation.vue?vue&type=template&id=0f9a053f&
// module id = null
// module chunks = 